<template>
  <div
    class="sub-nav-drawer-wrap"
    :class="{subActive:slideActive}"
  >
    <div class="sub-nav-drawer">
      <div
        class="slide-btn"
        @click="$_slideClose()"
      >
        <i class="icon-arrow-left" />
      </div>
      <div class="nav-title">
        <i class="icon-nav-filemanage-open" />
        <p>{{ $t(title) }}</p>
      </div>
      <perfect-scrollbar class="nav-list">
        <div
          v-for="(item,itemIndex) in menuItems"
          :key="itemIndex"
          class="nav-list_text-wrap"
          :class="{disable:item.disabled}"
          @click="$_buttonClick(item)"
        >
          <router-link
            class="nav-list_text"
            :to="item.link && !item.disabled ? $_getRouterLink(item.link):''"
            :class="{active: $_getActiveByIngViewName(item.id)}"
            :disabled="item.disabled"
          >
            {{ $t(item.textLabel) }}
          </router-link>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>
<script>
export default {
  name: "SubNavDrawer",
  props: {
    menuItems: {
      type: Array,
      default() {
        return [];
      },
    },
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    window: {
      width: 0,
      height: 0,
    },
    slideActive: false,
  }),
  computed: {
    _ingViewName() {
      if (!this.$route.meta.name) return;
      return this.$route.meta.name;
    },
    _currentFactoryId() {
      return this.$route.params.factoryId;
    },
    _currentOrganizationId() {
      return this.$route.params.organizationId;
    },
  },
  mounted() {
    this.$_handleResize();
  },
  created() {
    window.addEventListener("resize", this.$_handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.$_handleResize);
  },
  methods: {
    $_getRouterLink(link) {
      if (this._currentFactoryId) {
        return `/factory/${this._currentFactoryId}${link}`;
      } else if (this._currentOrganizationId) {
        return `/organization/${this._currentOrganizationId}${link}`;
      }
    },
    $_handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    $_slideOpen() {
      this.slideActive = true;
    },
    $_slideClose() {
      this.slideActive = false;
      this.$emit("click");
    },
    $_buttonClick() {
      if (this.window.width < 1200) {
        this.slideActive = false;
        this.$emit("click");
      }
    },
    $_getActiveByIngViewName(viewId) {
      if (!this._ingViewName) return;
      if (this._ingViewName.includes(viewId)) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/sub-nav-drawer";
</style>